import React, { memo } from "react";
import { COLORS } from "../config/themes";
import Icon from "./Icon";

const Modal = memo(({ open, onClose, title, children, wide }) => {
  if (!open) return null;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", paddingTop: "6vh" }}>
      <div className="anim-modal-overlay" style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.35)", backdropFilter: "blur(4px)" }} />
      <div className="anim-modal-content" onClick={e => e.stopPropagation()} style={{ position: "relative", background: COLORS.card, borderRadius: 20, padding: 32, maxWidth: wide ? 720 : 520, width: "92%", maxHeight: "88vh", overflow: "auto", boxShadow: "0 24px 80px rgba(0,0,0,0.18)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h3 style={{ margin: 0, fontSize: 20, fontFamily: "'Nunito', sans-serif", fontWeight: 800, color: COLORS.navy }}>{title}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: COLORS.textMuted, padding: 4 }}><Icon name="x" /></button>
        </div>
        {children}
      </div>
    </div>
  );
});

export default Modal;
